import React from 'react';
import '../../Default.css';

import topics_file from "./topisc.json"
import TopicType from './topicType';
const topics: TopicType[] = topics_file as any;

function Topic() {
    return (
      <>
        <div className="page-title">
          Tematy spotkań katechetycznych RISE UP
        </div>
        <div className='boxes-contener'>
            <div className='copyright-tekst'>Przewodnik ŚDM</div>
            {topics.map((elem, index) => <div className='text-box-align' key={index}>
                <div className='text-box-small-accent'>{elem.day}</div>
                <div className="paragraf">Słowo z Pisma Św.: <b>{elem.word}</b></div>
                <div className="paragraf">Fundament: <b>{elem.foundation}</b></div>
                <div className="paragraf">Temat społeczny do refleksji: <b>{elem.theme}</b></div>
                <div className="paragraf">{elem.description}</div>
            </div>)}
        </div>
      </>
    );
}

export default Topic;
